import Component from '../core/Component'
import 'waypoints/lib/noframework.waypoints.js'
import { triggerEvent } from '../utils/dom'

export default class PaginatorAutoload extends Component {

    prepare() {
        this.waypoint = new Waypoint({
            element: this.element,
            handler: ::this.handleTrigger,
            offset: () => Waypoint.viewportHeight() + 400
        })
    }

    destroy() {
        this.waypoint.destroy()
        this.waypoint = null
    }

    handleTrigger(direction) {
        if (direction === 'down') {
            triggerEvent(this.element, 'click')
        }
    }

}